export const SET_CURRENT_REVIEWS = 'SET_CURRENT_REVIEWS';

export const actionSetCurrentReviews = reviews => ({
    type: SET_CURRENT_REVIEWS,
    payload: reviews
})